import api from "../../services/admin_api_global";

// ── Coordinators ──────────────────────────────────────────────
export const fetchCoordinators      = (params)    => api.get("/admin/coordinators", { params });
export const createCoordinator      = (body)       => api.post("/admin/coordinators", body);
export const updateCoordinator      = (id, body)   => api.put(`/admin/coordinators/${id}`, body);
export const linkCoordinatorUser    = (id, body)   => api.put(`/admin/coordinators/${id}/link-user`, body);
export const disableCoordinator     = (id)         => api.put(`/admin/coordinators/${id}/disable`);
export const enableCoordinator      = (id)         => api.put(`/admin/coordinators/${id}/enable`);
export const deleteCoordinator      = (id)         => api.delete(`/admin/coordinators/${id}`);
export const fetchCoordinatorReport = (id)         => api.get(`/admin/coordinators/${id}/report`);
export const linkStudentEmail       = (id, body)   => api.post(`/admin/coordinators/${id}/student-emails`, body);

// ── Commissions ───────────────────────────────────────────────
export const fetchCommissions       = (params) => api.get("/admin/commissions", { params });
export const fetchCommissionSummary = ()       => api.get("/admin/commissions/summary");
export const createCommission       = (body)   => api.post("/admin/commissions", body);
export const updateCommission       = (id, body) => api.put(`/admin/commissions/${id}`, body);
export const deleteCommission       = (id)     => api.delete(`/admin/commissions/${id}`);
